import _defineProperty from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _extends from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["label", "onChange", "value", "error", "errorMessage", "onValueAfterError"],
  _excluded2 = ["buttonText", "onSubmit", "Input", "disabled"],
  _excluded3 = ["onCreditCardTypeChanged", "_inputRef"],
  _excluded4 = ["onCreditCardTypeChanged", "mt", "mb", "m", "pt", "pb", "p", "cardType"],
  _excluded5 = ["className", "inputRef", "value"],
  _excluded6 = ["hasCurrencyLabel", "currency"],
  _excluded7 = ["InputProps", "InputLabelProps", "containerClassName"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from 'react';
import _ from 'lodash';
import { Box } from 'rebass/styled-components';
import styled from 'styled-components';
import { space, width } from 'styled-system';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import MaskedInput from 'react-number-format';
import Cleave from 'cleave.js/react';
import { Tooltip } from 'shared/components';
import { mediaQueries } from 'shared/styles';
export var DefaultInput = function DefaultInput(_ref) {
  var label = _ref.label,
    _onChange = _ref.onChange,
    value = _ref.value,
    error = _ref.error,
    errorMessage = _ref.errorMessage,
    _ref$onValueAfterErro = _ref.onValueAfterError,
    onValueAfterError = _ref$onValueAfterErro === void 0 ? _.noop : _ref$onValueAfterErro,
    props = _objectWithoutProperties(_ref, _excluded);
  return __jsx(StyledTextInputWithLabel, _extends({
    variant: "filled",
    error: !!error,
    label: error && errorMessage ? errorMessage : label,
    value: value,
    onChange: function onChange(e) {
      if (_onChange) {
        _onChange(e);
      }
      if (error) {
        onValueAfterError(e);
      }
    }
  }, props));
};
export var FormattedInputWithButton = function FormattedInputWithButton(_ref2) {
  var buttonText = _ref2.buttonText,
    onSubmit = _ref2.onSubmit,
    _ref2$Input = _ref2.Input,
    Input = _ref2$Input === void 0 ? DefaultInput : _ref2$Input,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return __jsx(InputWithButtonContainer, props, __jsx(Input, _extends({}, props, {
    mt: "0",
    mb: "0",
    m: "0",
    pt: "0",
    pb: "0",
    p: "0"
  })), ' ', __jsx(InputButton, {
    onClick: onSubmit,
    disabled: disabled
  }, buttonText || 'Save'));
};
export var DateInput = function DateInput(props) {
  return __jsx(MaskedInput, _extends({
    displayType: "input",
    customInput: DefaultInput,
    format: "##/##/####",
    placeholder: "mm/dd/yyyy",
    mask: ['m', 'm', 'd', 'd', 'y', 'y', 'y', 'y']
  }, props));
};
export var ExpirationDateInput = function ExpirationDateInput(props) {
  return __jsx(MaskedInput, _extends({
    displayType: "input",
    customInput: DefaultInput,
    format: "##/####",
    placeholder: "mm/yyyy",
    mask: ['m', 'm', 'y', 'y', 'y', 'y']
  }, props));
};
export var CvvInput = function CvvInput(props) {
  var ctnWidth = props.width;
  return __jsx(CvvContainer, {
    width: ctnWidth
  }, __jsx(MaskedInput, _extends({
    displayType: "input",
    customInput: DefaultInput,
    format: "####"
  }, props)), __jsx(TooltipContainer, null, __jsx(Tooltip, {
    tooltipCopy: "The 3 or 4 digit number commonly found on the front or back of your credit card.",
    grey: true,
    width: "257px",
    left: "auto",
    right: "-42px",
    bottom: "25px",
    arrowRight: "42px"
  })));
};
export var PhoneNumberInput = function PhoneNumberInput(props) {
  return __jsx(MaskedInput, _extends({
    displayType: "input",
    customInput: DefaultInput,
    format: "(###) ###-####",
    placeholder: "(___) ___-____",
    mask: "_",
    type: "tel"
  }, props));
};
var CreditCardCleaveInput = function CreditCardCleaveInput(_ref3) {
  var _ref3$onCreditCardTyp = _ref3.onCreditCardTypeChanged,
    onCreditCardTypeChanged = _ref3$onCreditCardTyp === void 0 ? _.noop : _ref3$onCreditCardTyp,
    _inputRef = _ref3._inputRef,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return __jsx(Cleave, _extends({}, props, {
    options: {
      creditCard: true,
      onCreditCardTypeChanged: onCreditCardTypeChanged
    }
  }));
};
export var CreditCardInput = function CreditCardInput(_ref4) {
  var _ref4$onCreditCardTyp = _ref4.onCreditCardTypeChanged,
    onCreditCardTypeChanged = _ref4$onCreditCardTyp === void 0 ? _.noop : _ref4$onCreditCardTyp,
    mt = _ref4.mt,
    mb = _ref4.mb,
    m = _ref4.m,
    pt = _ref4.pt,
    pb = _ref4.pb,
    p = _ref4.p,
    cardTypeFromProps = _ref4.cardType,
    props = _objectWithoutProperties(_ref4, _excluded4);
  var _useState = useState(''),
    cardType = _useState[0],
    setCardType = _useState[1];
  function cardTypeChanged(type) {
    setCardType(type);
    onCreditCardTypeChanged(type);
  }
  var InputProps = {
    inputComponent: CreditCardCleaveInput,
    inputProps: {
      onCreditCardTypeChanged: cardTypeChanged
    }
  };
  return __jsx(CreditCardContainer, {
    className: "".concat(cardTypeFromProps, " ").concat(cardType),
    mt: mt,
    mb: mb,
    m: m,
    pt: pt,
    pb: pb,
    p: p
  }, __jsx(DefaultInput, _extends({
    InputProps: InputProps
  }, props)));
};
var DollarCleaveInput = function DollarCleaveInput(_ref5) {
  var _String;
  var className = _ref5.className,
    inputRef = _ref5.inputRef,
    value = _ref5.value,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return __jsx(Cleave, _extends({}, props, {
    value: value,
    className: "".concat(className, " --dollar-cleave ").concat(value && ((_String = String(value)) === null || _String === void 0 ? void 0 : _String.length) > 0 && '--has-value'),
    htmlRef: function htmlRef(ref) {
      return inputRef(ref);
    },
    options: {
      prefix: '$',
      numeral: true,
      numeralPositiveOnly: true,
      numeralThousandsGroupStyle: 'thousand'
    }
  }));
};
export var DollarInput = function DollarInput(_ref6) {
  var hasCurrencyLabel = _ref6.hasCurrencyLabel,
    _ref6$currency = _ref6.currency,
    currency = _ref6$currency === void 0 ? 'USD' : _ref6$currency,
    props = _objectWithoutProperties(_ref6, _excluded6);
  var InputProps = {
    inputComponent: DollarCleaveInput
  };
  if (hasCurrencyLabel) {
    InputProps.endAdornment = __jsx(EndAdornment, {
      position: "end"
    }, currency);
  }
  return __jsx(DefaultInput, _extends({
    InputProps: InputProps
  }, props));
};
var StyledTextInputWithLabel = styled(function (_ref7) {
  var _ref7$InputProps = _ref7.InputProps,
    InputProps = _ref7$InputProps === void 0 ? {} : _ref7$InputProps,
    _ref7$InputLabelProps = _ref7.InputLabelProps,
    InputLabelProps = _ref7$InputLabelProps === void 0 ? {} : _ref7$InputLabelProps,
    containerClassName = _ref7.containerClassName,
    props = _objectWithoutProperties(_ref7, _excluded7);
  return __jsx(TextField, _extends({}, props, {
    classes: {
      root: 'mui-dt-root'
    },
    InputProps: _objectSpread(_objectSpread({}, InputProps), {}, {
      classes: {
        root: "mui-dt-input-root ".concat(containerClassName || ''),
        input: 'mui-dt-input-input',
        error: 'mui-dt-input-error',
        underline: 'mui-dt-input-underline'
      }
    }),
    InputLabelProps: _objectSpread(_objectSpread({}, InputLabelProps), {}, {
      classes: {
        root: 'mui-dt-label-root',
        focused: 'mui-dt-label-focused',
        error: 'mui-dt-label-error',
        shrink: 'mui-dt-label-shrink'
      }
    })
  }));
}).withConfig({
  displayName: "text-input-with-label__StyledTextInputWithLabel",
  componentId: "sc-ynurre-0"
})(["&.mui-dt-root{", ";", ";}.mui-dt-input-root{background-color:var(--dcm-checkout-input-bg,#fcfdfe) !important;border:1px solid var(--dcm-checkout-input-border-color,#caced4);&.mui-dt-input-error{border:1px solid #e25241;}&.iframe-input{height:53px;@media only screen and (min-width:768px){height:45px;}iframe{height:16px !important;position:relative;transform:translate3d(19px,5px,0);transition:transform 0s,opacity 0.3s;@media only screen and (min-width:768px){transform:translate3d(17px,5px,0);}}.mui-dt-input-input{display:none;}}&.iframe-input.unfocused{iframe{opacity:0.00000000001;transition:transform 0s 0.1s,opacity 0.1s;transform:translate3d(0,0,0);height:100% !important;}}}.mui-dt-input-input{font-size:16px;padding:22px 5px 6px 20px;caret-color:#6fa48e;color:var(--dcm-checkout-text-color,#5d666d);height:23px;@media only screen and (min-width:768px){font-size:13px;height:19px;padding:19px 5px 5px 18px;}&.--dollar-cleave:not(.--has-value){color:transparent;&:focus{color:var(--dcm-checkout-text-color,#5d666d);}}&.credit-card-cleave.visa{position:relative;&:before{content:' ';height:10px;width:30px;background-color:red;position:absolute;top:50%;right:20px;transform:translate(-50%,-50%);}}&:disabled{cursor:not-allowed;opacity:0.75;}}.mui-dt-label-root{color:var(--dcm-checkout-text-muted-color,#858788);font-size:16px;transform:translate(20px,19px) scale(1);transition:color 200ms cubic-bezier(0,0,0.2,1) 0ms,transform 200ms cubic-bezier(0,0,0.2,1) 0ms,font-size 200ms cubic-bezier(0,0,0.2,1) 0ms;&.mui-dt-label-shrink{transform:translate(20px,10px);font-size:10px;@media only screen and (min-width:768px){transform:translate(18px,8px);--webkit-transform:translate(18px,8px);font-size:10px;}}&.mui-dt-label-error{color:#e25241 !important;}&.mui-dt-label-focused{color:var(--dcm-checkout-text-muted-color,#858788);}@media only screen and (min-width:768px){font-size:13px;transform:translate(18px,17px) scale(1);}}.mui-dt-input-underline:before{display:none;}.mui-dt-input-underline:after{transform:scale(0) !important;}.MuiFormLabel-asterisk{display:none;}.focus-visible{box-shadow:none !important;}.Mui-focused{border-color:", " !important;& > input,textarea{box-shadow:0px 1px 5px ", " !important;}background-color:var(--dcm-checkout-input-bg,", ") !important;}"], space, width, function (_ref8) {
  var _theme$colors$blue$, _theme$colors;
  var theme = _ref8.theme;
  return (_theme$colors$blue$ = theme === null || theme === void 0 || (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : _theme$colors.blue[55]) !== null && _theme$colors$blue$ !== void 0 ? _theme$colors$blue$ : '#4c94d7';
}, function (_ref9) {
  var _theme$colors$blueSha, _theme$colors2;
  var theme = _ref9.theme;
  return (_theme$colors$blueSha = theme === null || theme === void 0 || (_theme$colors2 = theme.colors) === null || _theme$colors2 === void 0 ? void 0 : _theme$colors2.blueShadow) !== null && _theme$colors$blueSha !== void 0 ? _theme$colors$blueSha : 'rgba(11, 153, 230, 0.4)';
}, function (_ref10) {
  var _theme$colors$white, _theme$colors3;
  var theme = _ref10.theme;
  return (_theme$colors$white = theme === null || theme === void 0 || (_theme$colors3 = theme.colors) === null || _theme$colors3 === void 0 ? void 0 : _theme$colors3.white) !== null && _theme$colors$white !== void 0 ? _theme$colors$white : '#fff';
});
var InputWithButtonContainer = styled(Box).withConfig({
  displayName: "text-input-with-label__InputWithButtonContainer",
  componentId: "sc-ynurre-1"
})(["position:relative;div:first-of-type{width:100%;}"]);
var InputButton = styled.button.withConfig({
  displayName: "text-input-with-label__InputButton",
  componentId: "sc-ynurre-2"
})(["appearance:none;border:none;padding:0;background-color:transparent;position:absolute;top:18px;right:20px;font-size:16px;font-weight:bold;color:#4597e0;cursor:pointer;@media only screen and (min-width:768px){top:17px;font-size:13px;}"]);
var EndAdornment = styled(InputAdornment).withConfig({
  displayName: "text-input-with-label__EndAdornment",
  componentId: "sc-ynurre-3"
})(["p{color:#a3afba;font-size:13px;font-weight:bold;line-height:15px;padding:2px 6px 0 0;}"]);
var CreditCardContainer = styled.div.withConfig({
  displayName: "text-input-with-label__CreditCardContainer",
  componentId: "sc-ynurre-4"
})(["position:relative;", ";&::after{content:'';position:absolute;top:50%;right:10px;transform:translate(-50%,-50%);background-repeat:no-repeat;height:28px;width:28px;background-image:url(/icons/default-card.svg);background-size:contain;@media ", "{right:2px;}}&.visa{&::after{background-image:url(/icons/visa.svg);}}&.mastercard,&.master.card{&::after{background-image:url(/icons/mastercard.svg);}}&.discover{&::after{background-image:url(/icons/discover.svg);}}&.amex,&.american.express{&::after{background-image:url(/icons/amex.svg);}}"], space, mediaQueries.largePhone);
var CvvContainer = styled.div.withConfig({
  displayName: "text-input-with-label__CvvContainer",
  componentId: "sc-ynurre-5"
})(["position:relative;", ";"], width);
var TooltipContainer = styled.div.withConfig({
  displayName: "text-input-with-label__TooltipContainer",
  componentId: "sc-ynurre-6"
})(["position:absolute;top:50%;right:15px;transform:translate(0,-50%);z-index:2;"]);